import { z } from "zod";
import { VALIDATION_MESSAGES_CARD } from "constants/validations";

// City Schema
export const citySchema = z
    .string()
    .min(1, { message: VALIDATION_MESSAGES_CARD.FIELD_REQUIRED })
    .max(20, { message: "Maximum 20 characters" })
    .regex(/^[a-zA-Z ]*$/, { message: "Must contain only letters" });

export const optionalCitySchema = z.union([z.literal(""), citySchema]).optional();
